import Seo from "@/components/Seo";
import PriceSimulator from "@/components/PriceSimulator";

const Simulator = () => (
  <div className="bg-white" data-testid="simulator-page">
    <Seo
      title="Simulateur de prix | Fast Alu"
      description="Estimation indicative pour vos travaux alu/métal, rideaux métalliques et vitrages."
    />
    <section className="bg-brand-blue/5" data-testid="simulator-hero">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl uppercase" data-testid="simulator-title">
          Simulateur de prix
        </h1>
        <p className="text-brand-ink/70 mt-4" data-testid="simulator-subtitle">
          Obtenez une estimation indicative avant votre devis définitif.
        </p>
      </div>
    </section>
    <section className="max-w-6xl mx-auto px-6 py-16" data-testid="simulator-content">
      <PriceSimulator />
    </section>
  </div>
);

export default Simulator;
